function Svg({ children, className = 'nav-icon', ...props }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconOverview(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="3" width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </Svg>
  );
}

export function IconPatterns(props) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="3" />
      <circle cx="16" cy="8" r="3" />
      <circle cx="12" cy="16" r="3" />
    </Svg>
  );
}

export function IconBuilder(props) {
  return (
    <Svg {...props}>
      <path d="M4 6h16M4 12h10M4 18h16" />
    </Svg>
  );
}

export function IconWeights(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 4v16M4 9h16M4 15h16" />
    </Svg>
  );
}

export function IconVersions(props) {
  return (
    <Svg {...props}>
      <path d="M7 7h10v12H7z" />
      <path d="M9 4h6v3H9z" />
      <path d="M9 12h6M9 15h4" />
    </Svg>
  );
}

export function IconResults(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4l3 2" />
    </Svg>
  );
}

export function IconContent(props) {
  return (
    <Svg {...props}>
      <path d="M6 4h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <path d="M15 4v5h5M8 13h8M8 17h5" />
    </Svg>
  );
}

export function IconAttempts(props) {
  return (
    <Svg {...props}>
      <path d="M4 19V5h12v14z" />
      <path d="M8 8h4M8 12h4M16 8h4v11H16" />
    </Svg>
  );
}

export function IconSpecialists(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c1.2-3.5 3.5-5 7-5s5.8 1.5 7 5" />
    </Svg>
  );
}

export function IconConsultations(props) {
  return (
    <Svg {...props}>
      <path d="M4 6h16v10H8l-4 4z" />
    </Svg>
  );
}

export function IconSupport(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M9.5 9a2.5 2.5 0 1 1 3.6 2.2c-.7.4-1.1.9-1.1 1.8V14" />
      <circle cx="12" cy="17" r="0.8" fill="currentColor" stroke="none" />
    </Svg>
  );
}

export function IconLegal(props) {
  return (
    <Svg {...props}>
      <path d="M12 3l8 4v6c0 4.5-3.2 7.5-8 8.5C7.2 20.5 4 17.5 4 13V7z" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  );
}

export function IconNotifications(props) {
  return (
    <Svg {...props}>
      <path d="M6 16h12l-1.2-2.2a6 6 0 0 1-.8-3V9a4 4 0 1 0-8 0v1.8c0 1.1-.3 2.1-.8 3z" />
      <path d="M10 16v1a2 2 0 0 0 4 0v-1" />
    </Svg>
  );
}

export function IconPlans(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="M8 9h8M8 13h5" />
    </Svg>
  );
}

export function IconCompanies(props) {
  return (
    <Svg {...props}>
      <path d="M4 20V8l6-3 6 3v12" />
      <path d="M10 20v-6h4v6" />
      <path d="M16 10h4v10h-4" />
    </Svg>
  );
}

export function IconPurchases(props) {
  return (
    <Svg {...props}>
      <path d="M6 7h12l-1 12H7z" />
      <path d="M9 7V6a3 3 0 0 1 6 0v1" />
    </Svg>
  );
}

export function IconEntitlements(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v8M9 11h6" />
    </Svg>
  );
}

export function IconBatches(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="5" width="7" height="14" rx="1.5" />
      <rect x="13" y="5" width="7" height="14" rx="1.5" />
    </Svg>
  );
}

export function IconCodes(props) {
  return (
    <Svg {...props}>
      <path d="M8 8l-4 4 4 4M16 8l4 4-4 4" />
    </Svg>
  );
}

export function IconSponsored(props) {
  return (
    <Svg {...props}>
      <path d="M12 4l2.2 6.5H21l-5.4 4 2.1 6.5L12 17.5 6.3 21l2.1-6.5L3 10.5h6.8z" />
    </Svg>
  );
}

export function IconMenu(props) {
  return (
    <Svg {...props}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </Svg>
  );
}

export function IconClose(props) {
  return (
    <Svg {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </Svg>
  );
}

export function IconChevron(props) {
  return (
    <Svg {...props}>
      <path d="M9 6l6 6-6 6" />
    </Svg>
  );
}

export function IconCollapse(props) {
  return (
    <Svg {...props}>
      <path d="M15 6l-6 6 6 6" />
    </Svg>
  );
}

export function IconEmpty(props) {
  return (
    <Svg {...props} width="48" height="48" className={props.className || 'empty-icon'}>
      <rect x="4" y="6" width="16" height="12" rx="2" />
      <path d="M8 22h8M6 18h12" />
    </Svg>
  );
}

export function IconSettings(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </Svg>
  );
}

const ICONS = {
  overview: IconOverview,
  patterns: IconPatterns,
  builder: IconBuilder,
  weights: IconWeights,
  versions: IconVersions,
  results: IconResults,
  content: IconContent,
  attempts: IconAttempts,
  specialists: IconSpecialists,
  consultations: IconConsultations,
  support: IconSupport,
  legal: IconLegal,
  notifications: IconNotifications,
  plans: IconPlans,
  companies: IconCompanies,
  purchases: IconPurchases,
  entitlements: IconEntitlements,
  batches: IconBatches,
  codes: IconCodes,
  sponsored: IconSponsored,
  menu: IconMenu,
  close: IconClose,
  chevron: IconChevron,
  collapse: IconCollapse,
  empty: IconEmpty,
};

export function NavIcon({ name, ...props }) {
  const Icon = ICONS[name] || IconOverview;
  return <Icon {...props} />;
}
